// Development server address - change this to your computer's local IP address
// You can find your IP address using:
// - On Mac/Linux: ifconfig or ip addr
// - On Windows: ipconfig
const DEV_SERVER_IP = 'localhost'; // Replace with your actual IP address

const config = {
  development: {
    apiUrl: `http://${DEV_SERVER_IP}:3000`
  },
  production: {
    apiUrl: 'https://sport-team-app.ru/api' // Replace with your production server URL
  },
  test: {
    apiUrl: `http://${DEV_SERVER_IP}:3000`
  }
};

const env = process.env.NODE_ENV || 'development';
export const API_URL = config[env] ? config[env].apiUrl : config.development.apiUrl;

// Dynamic WebSocket URL based on environment
const wsProtocol = (typeof window !== 'undefined' && window.location.protocol === 'https:') ? 'wss' : 'ws';
let wsHost;

// Choose WebSocket configuration method:
// Method 1: With nginx proxy (recommended) - use /ws path
// Method 2: Direct connection to port 3000 (requires firewall configuration)

const USE_NGINX_PROXY = true; // Set to false for direct connection

if (env === 'production') {
  if (USE_NGINX_PROXY) {
    // Method 1: Use nginx proxy with /ws path
    wsHost = (typeof window !== 'undefined') ? `${window.location.host}/ws` : 'sport-team-app.ru/ws';
  } else {
    // Method 2: Direct connection to port 3000
    wsHost = (typeof window !== 'undefined') ? `${window.location.hostname}:3000` : 'sport-team-app.ru:3000';
  }
} else {
  // In development, use localhost with port
  wsHost = `${DEV_SERVER_IP}:3000`;
}

export const WS_URL = `${wsProtocol}://${wsHost}`;

// Export config for testing
export default config; 